import apiClient from '@/api/client';
import type { Company, CompanyWithDetails } from '@/types/company';

export const getCompanies = async (): Promise<CompanyWithDetails[]> => {
  const response = await apiClient.get<CompanyWithDetails[]>('/companies');
  return response.data;
};

export const getCompany = async (id: string): Promise<CompanyWithDetails> => {
  const response = await apiClient.get<CompanyWithDetails>(`/companies/${id}`);
  return response.data;
};

export const createCompany = async (
  data: Omit<Company, 'id' | 'createdAt' | 'updatedAt'>,
): Promise<Company> => {
  const response = await apiClient.post<Company>('/companies', data);
  return response.data;
};

export const updateCompany = async (
  id: string,
  data: Partial<Omit<Company, 'id' | 'createdAt' | 'updatedAt'>>,
): Promise<Company> => {
  const response = await apiClient.put<Company>(`/companies/${id}`, data);
  return response.data;
};

export const deleteCompany = async (id: string): Promise<void> => {
  await apiClient.delete(`/companies/${id}`);
};
